import { createSlice } from "@reduxjs/toolkit";
import { getRequest } from "../../services/apiCaller/cl_index";
import staticGamesData from "../../assets/static.json";
import { endpoints } from "../../api/ApiEndPoints";
import { setErrorMessage } from "../signIn/cl_SignInSlice";

const initialState = {
  games: [],
  loader: false,
  searchInput: "",
  filteredGames: [],
  gapGamesUrl:'',
  gameDetails: [],
  gamePopup: false,
  getAllgamesList:[],
};
const crashGamesSlice = createSlice({
  name: "crashGames",
  initialState,
  reducers: {
    setGames: (state, action) => {
      state.games = action.payload;
    },
    setGameDetails: (state, action) => {
      state.gameDetails = action.payload;
    },
    setGamePopup: (state, action) => {
      state.gamePopup = action.payload;
    },
    setLoader: (state, action) => {
      state.loader = action.payload;
    },
    setSearchInput: (state, action) => {
      state.searchInput = action.payload;
    },
    setFilteredGames: (state, action) => {
      state.filteredGames = action.payload;
    },
    setGapGamesData:(state,action)=>{
      state.gapGamesUrl=action.payload
    },
    setGetAllgamesList:(state,action)=>{
      state.getAllgamesList=action.payload
    },
  },
});
export const { setGames, setLoader, setGameDetails, setGamePopup, setSearchInput,setFilteredGames,setGapGamesData ,setGetAllgamesList} =
  crashGamesSlice.actions;
export default crashGamesSlice.reducer;

export const fetchGamesData = () => async (dispatch) => {
  const url = endpoints?.fasfasDetails;

  dispatch(setLoader(true));
  const apiDataResponse = await fetch(url);
  const apiGamesData = await apiDataResponse.json();

  Promise.all([staticGamesData, apiGamesData])
    .then(([staticData, apiData]) => {
      dispatch(setLoader(false));
      const categorizedGames = staticData.categories.map((category) => {
        const games = category.games
          .map((game) => {
            return apiData.find(
              (apiGame) =>
                apiGame.aggregator === game.aggregator &&
                apiGame.provider === game.provider &&
                apiGame.gameCode === game.gamecode
            );
          })
          .filter(Boolean);

        return {
          category: category.category,
          games: games,
        };
      });

      dispatch(setGames(categorizedGames));
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
};

export const getSearchResults = (data, key) => (dispatch) => {
  if (!Array.isArray(data) || !key) {
    dispatch(setFilteredGames([])); 
    return;
  }

  const filtered = data.filter((game) => {
    if (!game) return false;
    
    const searchTerm = key.toLowerCase();
    const gameCode = game.game_code?.toLowerCase() || '';
    const provider = game.provider?.toLowerCase() || '';
    const name = game.name?.toLowerCase() || '';
    const configname = game.configname?.toLowerCase() || '';
    
    // For exact match of 'crash'
    if (searchTerm === 'crash') {
      return gameCode === 'crash' || name === 'crash' || configname === 'crash';
    }
    
    // For other search terms, use includes
    return (
      gameCode.includes(searchTerm) ||
      provider.includes(searchTerm) ||
      name.includes(searchTerm) ||
      configname.includes(searchTerm)
    );
  });

  // Remove duplicates based on both game_code and provider
  const uniqueFiltered = filtered.filter((game, index, self) =>
    index === self.findIndex((g) => 
      g.game_code === game.game_code && g.provider === game.provider
    )
  );

  dispatch(setFilteredGames(uniqueFiltered));
};
export const getGapLoadUrl = (data) => async (dispatch) => {
  const url = endpoints.gapBasePath;
  dispatch(setLoader(true));
  const apiDataResponse = await fetch(url,{
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  });
  if (!apiDataResponse.ok) {
   // throw new Error('Network response was not ok');
  }
  const apiGamesData = await apiDataResponse.json();

      dispatch(setLoader(false));
      // console.log(apiGamesData);
      dispatch(setGapGamesData(apiGamesData))
      return { url: apiGamesData?.url };
};

export const getAllGames = () => (dispatch) => {
  let gamesList = endpoints.allCmsGmaes;
  getRequest(gamesList).then((res) => {
    if (res?.status === 200) {
      dispatch(setGetAllgamesList(res?.data));
    } else {
      dispatch(setErrorMessage(res.message));
    }
  });
};